module.exports = __webpack_public_path__ + "img/Asset 3@150x@3x.958e6b2a.png";